/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    inboxIds,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        inbox_ids: inboxIds,
      },
    });
  }

  getSummary(since, until, type = 'account', id, groupBy, businessHours, page = 1, per_page = 10, inboxIds) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        page,
        per_page,
        inbox_ids: inboxIds,
      },
    });
  }

  checkCacheStatus(token) {
    return axios.get(`${this.url}/check_cache_status`, {
      params: { token }
    });
  }

  getConversationMetric(type = 'account', page = 1) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours, fileName, inboxIds }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours, fileName, inbox_ids: inboxIds },
    });
  }

  getConversationTrafficCSV() {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset() },
    });
  }

  getLabelReports({ from: since, to: until, businessHours, fileName }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours, fileName },
    });
  }

  getLabelTable(since, until, type = 'account', id, groupBy, businessHours,page = 1,per_page = 10){
    return axios.get(`${this.url}/label_table_summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        page,
        per_page
      },
    });
  }

  getLabelTableReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels_table`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours, fileName }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours, fileName },
    });
  }

  getTeamReports({ from: since, to: until, businessHours, fileName }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours, fileName },
    });
  }

  generateResolvedConversationsReport({ since, until }) {
    return axios.post(`${this.url}/resolved_conversations`, {
      since,
      until,
    });
  }

  checkResolvedReportStatus(token) {
    return axios.get(`${this.url}/check_resolved_report_status`, {
      params: { token },
    });
  }

  downloadResolvedReport(token) {
    return axios.get(`${this.url}/download_resolved_report`, {
      params: { token },
      responseType: 'blob',
    });
  }
}

export default new ReportsAPI();
